
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Job Nature",
    "tableTitle": "Job Nature List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/job_nature/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/job_nature`,
        edit: `${baseUrl}/api/mms/job_nature/edit`,
        delete: `${baseUrl}/api/mms/job_nature/remove`
    },
    "tableCol": [
        {
            name: 'Job Nature',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Job Nature',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "jobNature": "dgdg"
    }]
}